import {BoostIdDTO} from '@/domain/dtos/BoostDTO';
import {boostStore} from '@/entities/boost';

export function boostDeletedHandler(model: BoostIdDTO) {
  boostStore.removeBoostByBoostId(model.boost_id);
}
